import styled from "styled-components";
import { IThemeProps } from "./../../theme/index";
import { Card } from "@mui/material";
import { styledCardItem } from "../../../system/styles/globalStyles";

export const MyOpenCardStyle = styled(Card)`
  ${({ theme, isSmallCard }: IThemeProps & { isSmallCard: boolean }) => `
    height: 146px !important;
    background: ${theme.uptimeColors.grayScales.white};
    padding: 12px 16px;
    box-sizing: border-box;
    position: relative;
    ${styledCardItem()};
    @media (min-width: 386px) {
      width: ${isSmallCard ? "170px" : "100%"};
    }
    @media (min-width: 1280px) {
      width: ${isSmallCard ? "148px" : "100%"};
    }
    .MuiCardHeader-root{
      padding: 0 0 ${theme.uptimeSpace[8]}px;
    }
    .MuiGrid-container {
      justify-content: space-evenly;
    }
    .issue-type {
      font-size: ${theme.uptimeDynamicFontSize?.myOpenCard?.typeTicket};
      line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
      color: ${theme.uptimeColors.grayScales.darkerGray};
      margin-top: 10px;
      font-weight: 500;
      cursor: default;
    }
    .MuiGrid-item {
      text-align: center;
      .total-issue {
        width: 50px;
        height: 50px;
        background-color: ${theme.uptimeColors.mainTheme.background};
        margin: 0 auto;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: transform .5s;
        span {
          font-size: ${theme.uptimeDynamicFontSize?.myOpenCard?.totalTicket};
          font-weight: 500;
          line-height: ${theme.uptimeLineHeights.desktop.lh6}px;
          color: ${theme.uptimeColors.textColors.primary};
          display: block;
          width: 100%;
          padding-top: ${!!theme.uptimeFonts.primary ? (theme.uptimeDynamicAlignCenter?.activityCardSmallBox?.paddingTop ?? 0) : 0};
          @media (min-width: 960px) {
            font-size: ${theme.uptimeFontSizes.desktop.fz9}px;
            line-height: ${theme.uptimeLineHeights.desktop.lh7}px;
          }
        }
        &:hover {
          transform: scale(1.3);
        }
      }
    }
  `}
`;
